import { TdsMerchantsPage } from '@pages/tdsMerchants';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/u/$localId/_staff/staff/tds-merchants/')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['tds_merchants_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: TdsMerchantsPage,
});
